import React, { useState } from "react";
import { Send, Check, AlertCircle } from "lucide-react";
import { api, formatError } from "@/lib/api";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading"); setErr("");
    try {
      await api.post("/subscribe", { email });
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 5000);
    } catch (ex) {
      setStatus("error");
      setErr(formatError(ex));
    }
  };

  if (status === "success") {
    return (
      <div className="mt-6 flex items-center gap-3 border border-tratou-green/40 bg-tratou-green/5 px-4 py-3 text-tratou-green text-sm" data-testid="newsletter-success">
        <Check className="w-4 h-4 flex-shrink-0" />
        <span className="font-mono uppercase text-[11px] tracking-[0.18em]">Subscribed. Watch your inbox.</span>
      </div>
    );
  }

  return (
    <div className="mt-6">
      <form className="flex border border-white/10" onSubmit={submit} data-testid="newsletter-form">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 bg-transparent px-4 py-3 text-sm outline-none placeholder:text-tratou-faint text-white"
          data-testid="newsletter-input"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="btn-primary !py-3 !px-5 disabled:opacity-50"
          data-testid="newsletter-submit"
        >
          {status === "loading" ? "..." : (<>Subscribe <Send className="w-3.5 h-3.5" /></>)}
        </button>
      </form>
      {status === "error" && (
        <p className="mt-2 flex items-center gap-2 text-red-400 text-xs" data-testid="newsletter-error">
          <AlertCircle className="w-3.5 h-3.5" /> {err}
        </p>
      )}
    </div>
  );
}
